import { get } from 'common/utils/request';
export var fetchBenefitConversionApi = function () {
    return get('/benefits/common/conversion');
};
